import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-daily-logistics',
  templateUrl: './daily-logistics.component.html',
  styleUrls: ['./daily-logistics.component.css']
})
export class DailyLogisticsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
